<script setup lang="ts">
import { ref } from 'vue'
import { FilterField, TableField } from "../../../../components/table/table";
import { Permission } from '../../../../types/auth'
import ItemCategoriesForm from './ItemCategoriesForm.vue'
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";
import Buttons from '../../../../components/ui/form/Buttons.vue';
import ItemCategoriesImportExcel from './ItemCategoriesImportExcel.vue'
import { hasPermission } from "../../../../utils/CommonFunctions";

withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

defineEmits<{
  (e: "next"): void;
}>();


const endPoint = '/clients/inventory/item-management/item-categories/'
const title = 'Item Categories'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const permissions =  ref<Permission[]>([])

const showImportForm = ref(false)

const fields: TableField[] = [
  { name: 'photo', caption: 'Photo', sortable: true, fieldType: 'image' },
  { name: 'icon', caption: 'Icon', sortable: false, fieldType: 'svg' },
  { name: 'code', caption: 'Code', sortable: true, fieldType: 'text' },
  { name: 'name', caption: 'Name', sortable: true, fieldType: 'text' },
  { name: 'item_group', caption: 'Item Group', sortable: true, fieldType: 'text' },
  { name: 'is_group', caption: 'Is Group', sortable: true, fieldType: 'checkbox' },
  { name: 'parent_category', caption: 'Parent Category', sortable: true, fieldType: 'text' },
  { name: 'active', caption: 'active', sortable: false, fieldType: 'status' },
]

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data : any) => {
  selectedData.value = data
}
</script>

<template>
  <ListTemplate :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[]" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" 
  @data="handleData" :show-header="showHeader" :show-quick-tour="showQuickTour" :show-title="showTitle" @permissions="(data) => permissions = data">
  <template #header-actions>
    <Buttons icon="CircleArrowRight" caption="Next" @click="$emit('next')" v-if="showNextButton" />
    <Buttons icon="Import" caption="Import from Excel" @click="showImportForm = true" v-if="hasPermission(permissions, 'create')" />
  </template>
  <template #form-view>
    <ItemCategoriesForm
      :permissions="permissions"
      v-if="showForm"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />

  </template>  
  </ListTemplate>
  <ItemCategoriesImportExcel
      v-if="showImportForm"
      :end-point="endPoint"
      @save="refreshData = !refreshData"
      @close="showImportForm = !showImportForm"
    />
</template>